export default __webpack_public_path__ + "static/media/WalkwayStraight.256.9a2fc53d.png";